import { LinqFilterDTO, LinqFilterType } from './../models/linqPredicate.model';
import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { VATRateDTO, VATRateListDTO } from '../models/VATRate.model';
import { LinqPredicateDTO } from '../models/linqPredicate.model';
import { FilterService } from './filter.service';
import { LookupDTO } from '../models/lookup.model';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})

export class VATRateService {

  constructor(private http: HttpClient, private filterService: FilterService) {
  }

  getAllVATRates(linqPredicate: Array<LinqPredicateDTO> = null): Promise<Array<VATRateListDTO>> {

    if (linqPredicate == null || linqPredicate == undefined)
      linqPredicate = new Array<LinqPredicateDTO>();

    let isActive: LinqPredicateDTO = new LinqPredicateDTO();
    isActive.PropertyFilters = new Array<LinqFilterDTO>();
    isActive.PropertyFilters.push(LinqFilterDTO.createFilter("IsActive", true, LinqFilterType.Equal));

    let fk_companyPredicate: Array<LinqPredicateDTO> = this.filterService.getCompanyHierarchyFilter("FK_Company");
    fk_companyPredicate.push(isActive);

    //Lo accoda agli eventuali filtri che arrivano come parametri
    let linqPredicates: Array<LinqPredicateDTO> = fk_companyPredicate.concat(linqPredicate);

    return this.http.post<Array<VATRateDTO>>(environment.apiFullUrl + '/VatRate/GetAll/' + GlobalService.getUsedCompany(), linqPredicates).toPromise();
  }

  getVATRateByID(id: number): Promise<VATRateDTO> {
    return this.http.get<VATRateDTO>(environment.apiFullUrl + '/VatRate/' + id).toPromise();
  }

  saveVATRate(vatRate: VATRateDTO): Promise<any> {
    return this.http.post<any>(environment.apiFullUrl + '/VatRate', vatRate).toPromise()
  }

  deleteVATRate(id: number): Promise<any> {
    return this.http.delete<any>(environment.apiFullUrl + '/VatRate/' + id).toPromise();
  }

  setDisableStatus(id: number, fk_company : number, disableStatus: boolean): Promise<any> {
    return this.http.get<any>(environment.apiFullUrl + '/VatRate/' + id + '/' + fk_company + '/disablestatus/' + disableStatus).toPromise();
  }

  getAllLookupData(fk_company : number){
    return this.http.get<LookupDTO[]>(environment.apiFullUrl + '/VatRate/GetAllLookupData/' + fk_company).toPromise();
  }
}
